// extracted by mini-css-extract-plugin
export default {"content":"RevenueTab_content__XTeia","boxDate":"RevenueTab_boxDate__Q9mKb","total":"RevenueTab_total__lzylU"};